import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="21.998" height="22.001" viewBox="0 0 21.998 22.001">
        <path d="M21.5,19.064l-5.143-5.143a8.937,8.937,0,1,0-2.431,2.434L19.066,21.5A1.72,1.72,0,0,0,21.5,19.064ZM3.4,8.937a5.5,5.5,0,1,1,5.5,5.5A5.506,5.506,0,0,1,3.4,8.937Z" transform="translate(-0.001 0)"/>
    </svg>


}
